import { ReactComponent as IParqueLogo } from "assets/images/iparque.svg";
import { SelectField } from "iparque-components";
import styled, { css } from "styled-components";
import { breakpoints } from "theme/breakpoints";
import { Column } from "../styles";

interface StyledColumnProps {
  center?: boolean;
}

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 80px;

  @media (max-width: ${breakpoints.md}) {
    flex-direction: column;
    margin-top: 50px;

    .hide-on-mobile-devices {
      display: none;
    }
  }
`;

export const SocialIconsWrapper = styled.div`
  margin-top: 10px;
  margin-bottom: 60px;

  @media (max-width: ${breakpoints.md}) {
    margin: 30px 0 0;
  }

  > * {
    > svg {
      width: 32px;
      height: 32px;
    }

    :not(:first-child) {
      margin-left: 12px;
    }
  }
`;

export const StyledLogo = styled(IParqueLogo)`
  width: 100px;
  height: 80px;

  @media (max-width: ${breakpoints.md}) {
    margin-top: 50px;
  }
`;

export const ColumnRightWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const IconLabelContainer = styled.div`
  display: flex;
  align-items: center;

  .footer-icon {
    margin-right: 5px;
    width: 16px;
    fill: ${({ theme }) => theme.colors.dark};
  }
`;

export const StyledSelect = styled(SelectField)`
  width: 80%;
  padding-top: 0;
  font-size: 14px;
  min-width: 200px;

  .custom-select-value {
    font-family: ${({ theme }) => theme.typography.text.variant.body6.font};
    font-weight: ${({ theme }) => theme.typography.text.variant.body6.weight};
  }

  .custom-select-options {
    font-family: ${({ theme }) => theme.typography.text.variant.body6.font};
  }
`;

export const StyledColumn = styled(Column)<StyledColumnProps>`
  flex: 1;

  ${({ center }) =>
    center &&
    css`
      display: flex;
      justify-content: center;
    `}
`;

export const Ul = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;
